// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".invitation-form .form-input .field label.label{margin-left:.1rem}.invitation-modal .modal-card-body{overflow:hidden;padding-top:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
